import { render, staticRenderFns } from "./Noticebar.vue?vue&type=template&id=e2988e8a&scoped=true&"
import script from "./Noticebar.vue?vue&type=script&lang=js&"
export * from "./Noticebar.vue?vue&type=script&lang=js&"
import style0 from "./Noticebar.vue?vue&type=style&index=0&id=e2988e8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2988e8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2988e8a')) {
      api.createRecord('e2988e8a', component.options)
    } else {
      api.reload('e2988e8a', component.options)
    }
    module.hot.accept("./Noticebar.vue?vue&type=template&id=e2988e8a&scoped=true&", function () {
      api.rerender('e2988e8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Noticebar.vue"
export default component.exports